import moment from 'moment';

function clearInputMask(value) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(value)) {
        return value;
    }

    const dateFormat = 'DD/MM/YYYY';
    const isDate = moment(value, dateFormat, true).isValid();

    if (isDate) {
        return moment(value, dateFormat).toISOString();
    }

    return value.replace(/,|\.|-|\(|\)|_|\//g, '');
}

export { clearInputMask };
